<template>
	<v-navigation-drawer
		v-if='$vuetify.breakpoint.mdAndDown'
		id='mobile-drawer'
		v-model='showDrawer'
		:width='$vuetify.breakpoint.xsOnly ? "100%" : "70%"'
		disable-resize-watcher
		disable-route-watcher-watcher
		fixed
		right
		temporary
		touchless
	>
		<v-app-bar
			absolute
			color='beige'
			dense
			elevate-on-scroll
			height='44px'
			scroll-target='.v-navigation-drawer__content'
		>
			<v-toolbar-title class='primary--text font-weight-bold'>
				Fahrzeuge filtern
			</v-toolbar-title>
			<v-spacer />
			<v-btn icon @click='showDrawer = false'>
				<v-icon>
					fas fa-times
				</v-icon>
			</v-btn>
		</v-app-bar>

		<v-card
			id='filter-list-mobile'
			class='no-text-highlight pb-2 '
			elevation='0'
		>

			<v-list
				v-if='value'
				class='pa-0 mx-3'
				elevation='0'
				style='margin-top: 58.5px; margin-bottom: 62px'
			>

				<loading-spinner v-if='loading' text='Filter werden geladen...' />

				<v-list-group
					v-for='(filter, index) in filters'
					v-else
					:key='filter.label'
					v-model='filter.active'
					class='border my-3 light-border'
					elevation='0'
					style='min-height: 61px'
					no-action
					:ripple='!$store.actions.getDisabledStatus(filter)'
					:disabled='$store.actions.getDisabledStatus(filter)'
					@click='$store.actions.getDisabledStatus(filter) || filter.active ? "" : scrollTo($event)'
				>
					<template v-slot:activator>
						<v-list-item-content class='py-2' :disabled='$store.actions.getDisabledStatus(filter)' style='min-height: 61px'>
							<v-list-item-title class='font-weight-bold primary--text' v-html='filter.label' />
							<v-list-item-subtitle v-if='getDisplayLabel(filter)'>
								{{ getDisplayLabel(filter) }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</template>

					<v-list-item :id='"list-item-" + index' class='pa-0'>
						<v-list-item-content
							class='pa-2'
							style='max-height: calc(100vh - 180px); overflow-y: auto; overflow-x: hidden'
							@click='setFilterParams(filter)'
						>
							<component
								:is='getFilterComponentName(filter)'
								:key='filter.label'
								:filter.sync='filter'
							/>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
				<MobileOptionDrawer />
			</v-list>


			<v-dialog
				v-model='showDeleteModal'
				attach='#mobile-catalog'
				internal-activator
				max-width='80%'
				origin='bottom center'
			>
				<v-card>
					<v-toolbar
						color='beige'
						dense
						flat
					>
						<v-toolbar-title class='primary--text font-weight-bold'>
							Alle Filter löschen?
						</v-toolbar-title>
						<v-spacer />
						<v-btn icon @click='showDeleteModal = false'>
							<v-icon size='19'>
								fas fa-times
							</v-icon>
						</v-btn>
					</v-toolbar>

					<v-card-text class='py-3'>
						Wenn du alle Filter löschst werden dir wieder alle
						verfügbaren Fahrzeuge angezeigt.

						<v-row
							align='center'
							class='mt-3 delete-actions'
							dense
							justify='center'
						>
							<v-col class='text-center' cols='12'>
								<v-btn
									color='accent'
									depressed
									@click='resetFilters'
								>
									Alle Filter löschen
								</v-btn>
							</v-col>
							<v-col class='text-center' cols='12'>
								<v-btn
									color='primary'
									depressed
									outlined
									@click='showDeleteModal = false'
								>
									Abbrechen
								</v-btn>
							</v-col>
						</v-row>

					</v-card-text>
				</v-card>
			</v-dialog>


			<div id='drawer-actions' class='d-inline-flex'>
				<v-row class='ma-0 pa-0'>
					<v-col cols='12' class='pa-0 ml-0'>
						<v-btn
							class='mr-2 px-1 ml-1'
							elevation='5'
							style='height: 40px; border-radius: 2px !important; min-width: 40px !important;'
							@click='showDeleteModal = true'
						>
							<v-icon color='#a6a6a6' style='font-size: 21px'>
								far fa-trash-alt
							</v-icon>
						</v-btn>
						<v-btn
							color='accent'
							elevation='5'
							style='font-size: 15px; width: calc(100% - 57px); height: 40px !important; border-radius: 3px'
							@click='save'
						>
							Fahrzeuge anzeigen ({{ total_cars }}<span v-if='!isXss' class='ml-1'>gefunden</span>)
						</v-btn>
					</v-col>
				</v-row>
			</div>

		</v-card>

	</v-navigation-drawer>
</template>

<script>
import TilesFilter from './filter/TilesFilter'
import SliderFilter from './filter/SliderFilter'
import DurationFilter from './filter/DurationMobileFilter'
import SelectFilter from './filter/SelectFilter'
import ConditionFilter from './filter/ConditionFilter'
import LocationFilter from './filter/LocationFilter'
import DependencyFilter from './filter/DependencyFilter'
import RangeFilter from './filter/RangeFilter'
import PowerFilter from '@/components/filter/PowerFilter'
import LoadingSpinner from './LoadingSpinner'
import throttle from 'lodash.throttle'
import utils from '../libs/utils'
import cloneDeep from 'lodash.clonedeep'
import MobileOptionDrawer from '@/components/MobileOptionDrawer';

export default {
	name: 'MobileDrawer',
	components: {MobileOptionDrawer, LoadingSpinner, TilesFilter, LocationFilter, DurationFilter, SliderFilter, SelectFilter, ConditionFilter, RangeFilter, DependencyFilter, PowerFilter},

	props: {
		value: {
			required: true,
			type: Boolean
		}
	},

	data() {
		return {
      windowWidth: 0,
      showDeleteModal: false,
			filters: [],
			loading: true,
			total_cars: this.$store.pagination.total
		}
	},

	computed: {
    isXss() {
      return this.windowWidth < 400
    },
    showSearch() {
      return this.currentFilter.type === 'select' && Array.isArray(this.currentFilter.values) && this.currentFilter.values.length > 7
    },
		showDrawer: {
			get() {
				return this.value
			},
			set(val) {
				if (val) this.getFilters()

				this.filters.forEach(filter => filter.active = false)
				this.$store.filters.forEach(filter => filter.active = false)

				this.$emit('input', val)
			}
		},

		filterComponentName() {
			if (!this.currentFilter.type) {
			  return ''
      }
			if(this.currentFilter.type === 'slider') {
			  return 'SelectFilter';
      }
			return this.currentFilter.type.charAt(0).toUpperCase() + this.currentFilter.type.slice(1) + 'Filter'
		},
	},

	watch: {
		filters: {
			deep: true,
			immediate: true,
			handler: throttle(function () {
					this.$store.actions.getVehiclesCount(this.filters).then(res => this.total_cars = res)
				}, 600
			)
		}
	},

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
	mounted() {
		// rerender when filter changes outside (eg. chips)
		this.$bus.$on('filters-updated', () => {
			this.$forceUpdate()
		})

    this.onResize();
    window.addEventListener('resize', this.onResize)
	},

     methods: {
         setFilterParams(filter){
           if(filter.name === 'brand') {
             this.$store.actions.updateFiltersInStore(this.filters)
           }
         },
		scrollTo(event) {
			setTimeout(() => {
				this.$nextTick(() => {
					this.$vuetify.goTo(event.target, {
						duration: 200,
						offset: 75,
						container: '.v-navigation-drawer__content',
						easing: 'easeOutCubic',
					})
				})
			}, 250)
		},
    onResize() {
      this.windowWidth = window.innerWidth
    },
		getDisplayLabel(filter) {
			return utils.getDisplayLabel(filter, true)
		},

		getDisabledStatus(filter) {
			return this.$store.actions.getDisabledStatus(filter, this.filters)
		},

		getFilterComponentName(filter) {
      if (!filter.type) {
        return '';
      }

			return filter.type.charAt(0).toUpperCase() + filter.type.slice(1) + 'Filter'
		},

		resetFilters() {
			this.$store.actions.resetAllFilters()
			this.getFilters()
			this.showDrawer = false
		},

		async getFilters() {
			const filters = await this.$store.actions.getFilters()
			// create copy to enable canceling of user inputs
			this.filters = cloneDeep(filters)
			this.loading = false
		},

		save() {
			this.$store.actions.updateFiltersInStore(this.filters).then(() => {
        this.showDrawer = false
      })
		},
	}
}
</script>

<style lang='scss'>
#mobile-catalog .v-dialog__content {
	align-items: flex-end;
	padding-bottom: 48px;
}

#filter-list-mobile .v-list-group__header.v-list-item {
	padding: 0 12px !important;
}
</style>

<style lang='scss' scoped>
@import 'src/styles/variables';

#drawer-actions {
	position: fixed;
	bottom: 16px;
  width: 100%;
}

.delete-actions .v-btn {
	min-width: 172px !important;
}
</style>